import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Input, Spin } from 'antd';
import axios from "axios";
import Swal from 'sweetalert2';
import MyPCMRecorder from "../../utils/MyPCMRecorder";
import { USER_SERVER, SOCKET_URL } from '../../../config'
import './Chat.css';
import { PhoneTwoTone, ApiTwoTone, SendOutlined } from '@ant-design/icons';
import MyPCMStreamPlayer from '../../utils/MyPCMStreamPlayer';
import testPCM from '../../../assets/tao.pcm';
import { linear16ToMulaw, mulawToLinear16 } from '../../utils/MyMuLawConverter';

const { TextArea } = Input;

function WebsocketChat({UserId, isCallActive}) {
    //const [Status, setStatus] = useState('ready');      // ready, intro_done, connect_done, start_done, need_close
    const [Socket, setSocket] = useState(null);    
    const [Ready, setReady] = useState(false);

    const [messages, setMessages] = useState([]);
    const [currentUserMessage, setCurrentUserMessage] = useState('');
    const [currentAssistantMessage, setCurrentAssistantMessage] = useState('');
    const currentAssistantMessageRef = useRef('');


    const historyRef = useRef(null);


    // useEffect(() => {
    //     if (UserId) {
    //         get_chat_history(UserId);
    //     }
    // }, [UserId]);


    useEffect(() => {
        if (historyRef.current) {
            historyRef.current.scrollTop = historyRef.current.scrollHeight;
        }
    }, [messages, currentAssistantMessage]);


    ////////////////////////////////////////// HTTP //////////////////////////////////////////
    async function get_chat_history(user_id) {
        try {
            const res = await axios.post(`${USER_SERVER}/get_chat_history`, { user_id: user_id });
            console.log('get_chat_history--------->', res);
            if (res.data?.success) {
                let tmp_messages = [];
                for (let i = 0; i < res.data.data.length; i++) {
                    if (res.data.data[i].speaker === 'h') {
                        tmp_messages.push({ type: 'user', text: res.data.data[i].message });
                    } else {
                        tmp_messages.push({ type: 'assistant', text: res.data.data[i].message });
                    }
                }
                setMessages(tmp_messages);
            } else {
                show_error(res);
            }
        } catch (error) {
            console.error('Failed to fetch chat history:', error);
            // 서버 연결 실패 시 기본 메시지 설정
            setMessages([{ type: 'system', text: '서버에 연결할 수 없습니다.' }]);
        }
    }


    // error 나면 에러 정보를 디스플레이
    function show_error(res) {
        console.log('show error:', res);
        const tdata = res.data.data;
        if (typeof tdata === 'object' && 'title' in tdata) {
            Swal.fire({
                title: res.data.data.title,
                text: res.data.data.description,
                icon: 'info',
                confirmButtonText: '확인'
            });
        } else {
            Swal.fire({
                title: 'Error',
                text: res.data.data,
                icon: 'error',
                confirmButtonText: '확인'
            });
        }
    }


    ////////////////////////////// SOCKET ////////////////////////////////
    // connect
    // async function start_connect() {
    //     const newSocket = new WebSocket(SOCKET_URL + '/socket_report');

    //     newSocket.onopen = () => {
    //         console.log('Connected to the server:', UserId);
    //         newSocket.send(JSON.stringify({ event: 'connected', "protocol":"Call", "version":"1.0.0"}));
    //         // Socket과 Status를 함께 업데이트
    //         Promise.all([
    //             new Promise(resolve => setSocket(newSocket)),
    //             new Promise(resolve => setStatus('connect_done'))
    //         ]).then(() => {
    //             console.log('Socket and Status updated');
    //         });
    //     };

    //     newSocket.onerror = (error) => {
    //         console.error('Connection error:', error.message);
    //     };
    // };


    // async function callback_recording(int16ArrayBuffer) {
    //     console.log('callback_recording data size:', int16ArrayBuffer.byteLength, 'bytes');
    //     if (!Socket) {
    //         console.error('Socket connection not established');
    //         return;
    //     }

    //     if (Socket.readyState === WebSocket.OPEN) {
    //         // mulaw 데이터로 변환
    //         const mulawData = linear16ToMulaw(int16ArrayBuffer);   // mulawData: Uint8Array

    //         const base64Data = btoa(String.fromCharCode.apply(null, mulawData));
    //         //console.log('base64Data:', base64Data);
    //         const dataToSend = JSON.stringify({ event: 'media', media: { payload: base64Data } })
    //         Socket.send(dataToSend);
    //     } else {
    //         console.error('Socket connection not open');
    //     }
    // }


    // async function start_start() {
    //     console.log('start_start:', Socket);

    //     // Socket이 준비될 때까지 대기 (최대 2초)
    //     let attempts = 0;
    //     while (!Socket && attempts < 20) {
    //         await new Promise(resolve => setTimeout(resolve, 100));
    //         console.log('start_start: waiting for socket...');
    //         attempts++;
    //     }

    //     if (!Socket) {
    //         console.error('Socket connection not established after timeout');
    //         return;
    //     }

    //     // player 먼저 생성 및 시작
    //     const player = new MyPCMStreamPlayer();
    //     player.start();
    //     setPlayer(player);

    //     // player가 state에 완전히 반영될 때까지 대기
    //     await new Promise(resolve => setTimeout(resolve, 500));

    //     // socket start 이벤트 전송: streamSid='0' 이면 twilio가 아닌 client에서 전송하는 것이라 약속함
    //     Socket.send(JSON.stringify({ event: 'start', 
    //         "start":{"streamSid":"0","callSid":UserId, "tracks":["inbound"],"mediaFormat":{"encoding":"audio/x-mulaw","sampleRate":8000,"channels":1},"customParameters":{}},"streamSid":"MZd4a86d1920fb3ff9165914bcc3857db2"}
    //     ));

    //     // recorder 생성
    //     const recorder = new MyPCMRecorder(callback_recording, 100, 8000);
    //     setRecorder(recorder);

    //     // status 업데이트
    //     setStatus('start_done');
    // }


    // async function start_websocket_phase() {
    //     console.log('start_websocket_phase');
    // }


    useEffect(() => {
        if (!isCallActive) {
            return;
        }

        const newSocket = new WebSocket(SOCKET_URL + '/socket_report');

        newSocket.onopen = () => {
            console.log('Connected to the server:', UserId);
            newSocket.send(JSON.stringify({ event: 'connected', "protocol":"Call", "version":"1.0.0", "from_user":UserId}));
            // Socket과 Status를 함께 업데이트
            Promise.all([
                new Promise(resolve => setSocket(newSocket)),
            ]).then(() => {
                console.log('Socket and Status updated');
            });
        };

        newSocket.onmessage = (event) => {
            const res = JSON.parse(event.data);
            console.log('socket_recv:', res);
            if (res.event === 'asr_result') {
                handleUserSend(res.asr_result);
            }
            else if (res.event === 'answer') {
                handleGetAnswerResponse(res.answer);
            }
        };

        newSocket.onclose = async () => {
            console.log('Disconnected from server');
        };


        newSocket.onerror = (error) => {
            console.error('Connection error:', error.message);
        };

    }, [isCallActive]);

    // // Socket의 onmessage 핸들러를 useEffect로 분리
    // useEffect(() => {
    //     if (!Socket) return;

    //     Socket.onmessage = (event) => {
    //         const res = JSON.parse(event.data);
    //         if (res.event === 'media') {
    //             if (!Player) {
    //                 console.warn('Waiting for player initialization...');
    //                 return;
    //             }
    //             const base64Data = res.media.payload;
    //             const binaryString = atob(base64Data);
    //             const bytes = new Uint8Array(binaryString.length);
    //             for (let i = 0; i < binaryString.length; i++) {
    //                 bytes[i] = binaryString.charCodeAt(i);
    //             }
                
    //             // mulaw 데이터를 linear16으로 변환
    //             const linear16Data = mulawToLinear16(bytes);
    //             Player.add_data(linear16Data.buffer);
    //         }
    //         else if (res.event === 'answer') {
    //             handleGetAnswerResponse(res.answer);
    //         }
    //         else if (res.event === 'asr_result') {
    //             console.log('socket_recv:asr_result', res.asr_result);
    //             handleUserSend(res.asr_result);
    //         }
    //     };

    //     return () => {
    //         Socket.onmessage = null;
    //     };
    // }, [Socket, Player]);


    // useEffect(() => {
    //     if (Socket) {
    //         Socket.onclose = async () => {
    //             console.log('Disconnected from server');
    //             setStatus('ready');
    //         };
    //     }
    // }, [Socket]);



    ///////////////////// END OF SOCKET ////////////////////////////////


    //////////////////////////////////////////////// ChatBubble ////////////////////////////////////////////////

    const handleUserInputChange = (e) => {
        setCurrentUserMessage(e.target.value);
    };

    const handleUserSend = (message) => {
        if (message.trim()) {
            //setMessages([...messages, { type: 'user', text: currentUserMessage }]);
            setMessages(prevMessages => [...prevMessages, { type: 'user', text: message }]);
            setCurrentUserMessage('');
        }
    };

    function handleAssistantSend(message) {
        console.log('handleAssistantSend called:', message);
        if (message.trim()) {
            console.log('handleAssistantSend called 2');
            setMessages(prevMessages => [...prevMessages, { type: 'assistant', text: message }]);
        }
    }


    // async function onClickSend() {
    //     if (Status !== 'start_done') {
    //         return;
    //     }

    //     handleUserSend(currentUserMessage);
    //     await send_question(currentUserMessage);
    // }

    function handleGetAnswerResponse(res) {
        //console.log('socket_recv:answer', res);

        if (res === '<EOS>') {
            handleAssistantSend(currentAssistantMessageRef.current);
            currentAssistantMessageRef.current = ''; // 메시지 초기화
            setCurrentAssistantMessage('');
        } else {
            currentAssistantMessageRef.current += res; // 메시지 추가
            setCurrentAssistantMessage(prevMessages => prevMessages + res); // UI 업데이트를 위해 상태 설정
        }
    };



    
    /////////////////////////////////////// Display ///////////////////////////////////////
    //const normal_operation = (Status === 'start_done');


    return (
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>
            {/* <Row align="middle" justify="space-between" style={{ marginTop: '10px' }}>
                <Col span={20} style={{ textAlign: 'center' }}>

                    {CallReady ? 
                        <PhoneTwoTone
                            onClick={onClickCallConnect}
                            style={{


                                fontSize: '32px',
                                borderRadius: '50%',
                                border: '2px solid lightblue',
                                padding: '8px'
                            }}
                        /> :
                        <ApiTwoTone
                            onClick={onClickCallDisconnect}
                            style={{
                                fontSize: '32px',
                                borderRadius: '50%',
                                border: '2px solid lightblue',
                                padding: '8px'
                            }}
                        />
                    }
                </Col>
                <Col span={4} style={{ textAlign: 'right' }}>
                    <div style={{
                        padding: '1px',
                        borderRadius: '5px',
                        color: 'white',
                        backgroundColor: normal_operation ? 'green' : 'red',
                        display: 'inline-block',
                        fontSize: '12px'
                    }}>
                        {Status}
                    </div>
                </Col>
            </Row> */}

            <h3>Chat</h3>
            {/* chat history를 보여줌  */}
            <Row>
                <Col span={24}>
                    <div className="history" ref={historyRef}>
                        {messages.map((msg, index) => (
                            <div key={index} className={`message-bubble ${msg.type}`}>
                                {msg.text}
                            </div>
                        ))}
                        {/* Curr User:
                        {currentUserMessage && (
                            <div className="message-bubble user">
                                {currentUserMessage}
                            </div>
                        )} */}
                        {/* Curr Assistant: */}
                        {currentAssistantMessage && (
                            <div className="message-bubble assistant">
                                {currentAssistantMessage}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            {/* <Row justify="center" align='middle'>
                <Col span={22}>
                    <Input disabled={!normal_operation} value={currentUserMessage} onChange={handleUserInputChange} onPressEnter={onClickSend} />
                </Col>
                <Col span={2}>

                    {
                        WaitAnswer ? <Spin /> :
                            normal_operation ? <SendOutlined
                                onClick={normal_operation ? onClickSend : null}
                                style={{ fontSize: '24px', margin: 10, opacity: normal_operation ? 1 : 0.2 }}
                            /> :
                                <SendOutlined style={{ fontSize: '24px', margin: 10, opacity: 0.2 }} />
                    }
                </Col>
            </Row> */}


        </div>



    )
}

export default WebsocketChat
